export default __webpack_public_path__ + "static/media/Bracer of the Katari.393e1139.jpg";